export const defaultCellContent = '—';

export const DEFAULT_NO_RESULTS_TEXT = 'No results found. Please adjust your filters or search.';
